import { render, staticRenderFns } from "./ShippingCarrierProfile.vue?vue&type=template&id=65c1d1f4"
import script from "./ShippingCarrierProfile.vue?vue&type=script&lang=js"
export * from "./ShippingCarrierProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports